import { useState, useCallback } from 'react'

export interface UseDiscussionPanelReturnValue {
  isOpen: boolean
  toggle: () => void
  open: () => void
  close: () => void
}

export const useDiscussionPanel = (): UseDiscussionPanelReturnValue => {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = useCallback(() => {
    setIsOpen(prev => !prev)
  }, [])

  const open = useCallback(() => {
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
  }, [])

  return {
    isOpen,
    toggle,
    open,
    close,
  }
}
